module.exports = __webpack_public_path__ + "img/35.4c73f4ba.png";